import { Theme } from "@mui/material";

const MuiLink = (theme: Theme) => ({
  defaultProps: {
    color: "primary",
    underline: "none",
  },
  styleOverrides: {
    root: {
      fontWeight: "bold",
    },
  },
});
export default MuiLink;
